import { render } from "./CollectionItemTitle.vue?vue&type=template&id=919662c2"
import script from "./CollectionItemTitle.vue?vue&type=script&lang=js"
export * from "./CollectionItemTitle.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__